/**
 * @deprecated This component has been moved to @starjack/entities/ticket.
 * Please use TicketsOverviewUI from '@starjack/entities/ticket' instead.
 * This file is kept for backward compatibility and will be removed in a future version.
 *
 * Migration guide:
 * - Replace: import { TicketsOverviewUI } from '@/components/TicketsOverviewUI/TicketsOverviewUI'
 * - With: import { TicketsOverviewUI } from '@starjack/entities/ticket'
 */
import { FunctionComponent, useMemo } from 'react';
import { I18nextProvider } from 'react-i18next';
import {
    TicketsOverviewContainerProps,
    TicketsOverviewContainer,
} from '@/components/TicketsOverviewUI/TicketsOverviewUIContainer';
import { initI18nNextTicketOverview } from '@/components/TicketsOverviewUI/i18n/initI18n';

/**
 * @deprecated This type has been moved to @starjack/entities/ticket.
 * Please use TicketsOverviewUIProps from '@starjack/entities/ticket' instead.
 */
type TicketsOverviewUIProps = {
    locale?: string;

    translations?: {
        en?: Record<string, string>;
        de?: Record<string, string>;
    };
} & TicketsOverviewContainerProps;

/**
 * @deprecated This component has been moved to @starjack/entities/ticket.
 * Please use TicketsOverviewUI from '@starjack/entities/ticket' instead.
 */
export const TicketsOverviewUI: FunctionComponent<TicketsOverviewUIProps> = ({
    locale = 'de',
    translations,
    ...props
}) => {
    const i18n = useMemo(
        () =>
            initI18nNextTicketOverview({
                lng: locale,
                translations,
            }),
        []
    );

    if (locale !== i18n.language) {
        i18n.changeLanguage(locale);
    }

    return (
        <I18nextProvider i18n={i18n}>
            <TicketsOverviewContainer {...props} />
        </I18nextProvider>
    );
};
